import Vue from 'vue'
import VueRouter from 'vue-router'

import mgrLayout from './views/mgr-layout'
import login from './views/login'

const welcome = r =>
  require.ensure([], () => r(require('./views/welcome')), 'login')
const home = r => require.ensure([], () => r(require('./views/home')), 'login')

const mediaAgreement = r =>
  require.ensure(
    [],
    () => r(require('./views/material/agreement')),
    'media-agreement'
  )

const material = r =>
  require.ensure([], () => r(require('./views/material/material')), 'material')
const videoCreate = r =>
  require.ensure(
    [],
    () => r(require('./views/material/video-create')),
    'material'
  )
const articleCreate = r =>
  require.ensure(
    [],
    () => r(require('./views/material/article-create')),
    'material'
  )
const audioCreate = r =>
  require.ensure(
    [],
    () => r(require('./views/material/audio-create')),
    'material'
  )
const d3Create = r =>
  require.ensure([], () => r(require('./views/material/3d-create')), 'material')
const u3dCreate = r =>
  require.ensure(
    [],
    () => r(require('./views/material/u3d-create')),
    'material'
  )

const project = r =>
  require.ensure([], () => r(require('./views/project/project')), 'project')

const miniapp = r =>
  require.ensure([], () => r(require('./views/miniapp/project')), 'miniapp')

const projectCreate = r =>
  require.ensure(
    [],
    () => r(require('./views/project/project-create')),
    'project'
  )

const miniappCreate = r =>
  require.ensure(
    [],
    () => r(require('./views/miniapp/project-create')),
    'miniapp'
  )

const projectEdit = r =>
  require.ensure(
    [],
    () => r(require('./views/project/project-edit')),
    'project'
  )

const miniappEdit = r =>
  require.ensure(
    [],
    () => r(require('./views/miniapp/project-edit')),
    'miniapp'
  )

const projectView = r =>
  require.ensure(
    [],
    () => r(require('./views/project/project-view')),
    'project'
  )

const miniappView = r =>
  require.ensure(
    [],
    () => r(require('./views/miniapp/project-view')),
    'miniapp'
  )

const projectCheck = r =>
  require.ensure(
    [],
    () => r(require('./views/project/project-check')),
    'project'
  )

const miniappCheck = r =>
  require.ensure(
    [],
    () => r(require('./views/miniapp/project-check')),
    'miniapp'
  )

const projectContents = r =>
  require.ensure(
    [],
    () => r(require('./views/project/project-contents')),
    'project'
  )

const miniappContents = r =>
  require.ensure(
    [],
    () => r(require('./views/miniapp/project-contents')),
    'miniapp'
  )

const contentCreate = r =>
  require.ensure(
    [],
    () => r(require('./views/project/content-create')),
    'project'
  )

const miniappContentCreate = r =>
  require.ensure(
    [],
    () => r(require('./views/miniapp/content-create')),
    'miniapp'
  )

const projectCheckContent = r =>
  require.ensure(
    [],
    () => r(require('./views/project/project-check-contents')),
    'project'
  )

const miniappCheckContent = r =>
  require.ensure(
    [],
    () => r(require('./views/miniapp/project-check-contents')),
    'miniapp'
  )

const userStat = r =>
  require.ensure([], () => r(require('./views/stat/user-stat')), 'stat')
const projectStat = r =>
  require.ensure([], () => r(require('./views/stat/project-stat')), 'stat')
const projectDetailStat = r =>
  require.ensure(
    [],
    () => r(require('./views/stat/project-detail-stat')),
    'stat'
  )

const appStat = r =>
  require.ensure([], () => r(require('./views/stat/app-stat.vue')), 'stat')

const miniappStat = r =>
  require.ensure([], () => r(require('./views/stat/miniapp-stat.vue')), 'stat')

const shared = r =>
  require.ensure([], () => r(require('./views/setting/shared')), 'stat')

const setting = r =>
  require.ensure([], () => r(require('./views/setting/profile')), 'setting')

Vue.use(VueRouter)

const routes = [
  {
    name: 'index',
    path: '/',
    component: mgrLayout
  },
  {
    name: 'login',
    path: '/login',
    component: login
  },
  {
    name: 'mediaAgreement',
    path: '/web-mgr/media/agreement',
    component: mediaAgreement
  },
  {
    name: 'layout',
    path: '/web-mgr',
    component: mgrLayout,
    children: [
      {
        name: 'mgr',
        path: '',
        component: welcome
      },
      {
        path: '/',
        redirect: {
          name: 'mgr'
        }
      },
      {
        name: 'home',
        path: 'home',
        component: home
      },
      {
        name: 'material',
        path: 'material',
        component: material
      },
      {
        name: 'mVideoCreate',
        path: 'material/video/create',
        component: videoCreate
      },
      {
        name: 'mArticleCreate',
        path: 'material/article/create',
        component: articleCreate
      },
      {
        name: 'mArticleEdit',
        path: 'material/article/edit',
        component: articleCreate
      },
      {
        name: 'mAudioCreate',
        path: 'material/audio/create',
        component: audioCreate
      },
      {
        name: 'm3dCreate',
        path: 'material/3d/create',
        component: d3Create
      },
      {
        name: 'mU3dCreate',
        path: 'material/u3d/create',
        component: u3dCreate
      },
      {
        name: 'project',
        path: 'project',
        component: project
      },
      {
        name: 'miniapp',
        path: 'miniapp',
        component: miniapp
      },
      {
        name: 'projectCreate',
        path: 'project/create',
        component: projectCreate
      },
      {
        name: 'miniappCreate',
        path: 'miniapp/create',
        component: miniappCreate
      },
      {
        name: 'projectCreateContents',
        path: 'project/create-contents',
        component: projectContents
      },
      {
        name: 'miniappCreateContents',
        path: 'miniapp/create-contents',
        component: miniappContents
      },
      {
        name: 'projectContentCreateWithNew',
        path: 'project/content/createwithnew',
        component: contentCreate
      },
      {
        name: 'miniappContentCreateWithNew',
        path: 'miniapp/content/createwithnew',
        component: miniappContentCreate
      },
      {
        name: 'projectContentCreate',
        path: 'project/content/create',
        component: contentCreate
      },
      {
        name: 'miniappContentCreate',
        path: 'miniapp/content/create',
        component: miniappContentCreate
      },
      {
        name: 'projectContentEdit',
        path: 'project/content/edit',
        component: contentCreate
      },
      {
        name: 'miniappContentEdit',
        path: 'miniapp/content/edit',
        component: miniappContentCreate
      },
      {
        name: 'projectEdit',
        path: 'project/edit',
        component: projectEdit
      },
      {
        name: 'miniappEdit',
        path: 'miniapp/edit',
        component: miniappEdit
      },
      {
        name: 'projectView',
        path: 'project/view',
        component: projectView
      },
      {
        name: 'miniappView',
        path: 'miniapp/view',
        component: miniappView
      },
      {
        name: 'check',
        path: 'check',
        component: { render: h => h('router-view') },
        children: [
          {
            name: 'projectContentsCheck',
            path: 'project/contents/check',
            component: projectCheckContent
          },
          {
            name: 'miniappContentsCheck',
            path: 'miniapp/contents/check',
            component: miniappCheckContent
          },
          {
            name: 'projectCheck',
            path: 'project/check/:type',
            component: projectCheck
          },
          {
            name: 'miniappCheck',
            path: 'miniapp/check/:type',
            component: miniappCheck
          },
          {
            name: 'shared',
            path: 'project/shared',
            component: shared
          }
        ]
      },
      {
        name: 'stat',
        path: 'stat',
        component: { render: h => h('router-view') },
        children: [
          {
            name: 'user-stat',
            path: 'user-stat',
            component: userStat
          },
          {
            name: 'project-stat',
            path: 'project-stat',
            component: projectStat
          },
          {
            name: 'projectdetail',
            path: 'projectdetail/:id',
            component: projectDetailStat
          },
          {
            name: 'app-stat',
            path: 'app-stat',
            component: appStat
          },
          {
            name: 'miniapp-stat',
            path: 'miniapp-stat',
            component: miniappStat
          }
        ]
      },
      {
        name: 'setting',
        path: 'setting',
        component: { render: h => h('router-view') },
        children: [
          {
            name: 'profile',
            path: 'profile',
            component: setting
          }
        ]
      }
    ]
  },
  {
    name: '404',
    path: '*',
    redirect: {
      name: 'home'
    }
  }
]

const router = new VueRouter({
  mode: 'history', // 这样url就没有/#/XXX,而是常见的url形式
  routes: routes, // short for routes: routes
  linkActiveClass: 'active', // router-link的选中状态的class，也有一个默认的值
  history: true
})

export default router
